// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z126bQD8msn2Lw22 {
  background: transparent;
  border: none;
  outline: none;
  padding: 4px;
  margin-left: 8px;
  color: #20336c;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.z126bQD8msn2Lw22:hover {
  color: #16244d;
}

.z126bQD8msn2Lw22 i {
  font-size: 22px;
}

.ODHYxlywEF80Zrwc {
  position: fixed;
  z-index: 10000;
  width: 320px;
  max-width: calc(100vw - 24px);
  background-color: #ffffff;
  color: #303030;
  border-radius: 16px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.18);
  padding: 16px;
  font-family: "Roboto";
  pointer-events: auto;
}

.AcBUL7jiutErC2Dn {
  font-size: 16px;
  font-weight: 700;
  color: #20336c;
  margin: 0 0 8px;
  word-break: break-word;
}

.eXAIwkKJWkEq7VPH {
  width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: 12px;
  background-color: #eeeeee;
  margin-bottom: 10px;
}

.DX31dxmn3UucL516 {
  font-size: 13px;
  line-height: 1.45;
  color: #303030;
  margin: 0 0 10px;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.H2otxh00CR4siz0b {
  font-size: 13px;
  color: #6b6b6b;
  text-align: center;
  margin: 8px 0;
}

.hXk2Jn5yP2cz1PhC {
  font-size: 13px;
  color: #c93838;
  text-align: center;
  margin: 8px 0;
}

.y2owRiwXog8YVO2I {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #20336c;
  text-decoration: none;
  font-weight: 600;
}

.y2owRiwXog8YVO2I:hover {
  text-decoration: underline;
}

.GcSORYRpR9MZ28bx {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}

@media screen and (max-width: 1024px) {
  .z126bQD8msn2Lw22 i {
    font-size: 18px;
  }

  .ODHYxlywEF80Zrwc {
    width: 280px;
    padding: 12px;
    border-radius: 12px;
  }

  .eXAIwkKJWkEq7VPH {
    height: 140px;
    border-radius: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/OrderPage/components/MenuItemInfoModal.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":[".infoIconBtn {\r\n  background: transparent;\r\n  border: none;\r\n  outline: none;\r\n  padding: 4px;\r\n  margin-left: 8px;\r\n  color: #20336c;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.infoIconBtn:hover {\r\n  color: #16244d;\r\n}\r\n\r\n.infoIconBtn i {\r\n  font-size: 22px;\r\n}\r\n\r\n.tooltip {\r\n  position: fixed;\r\n  z-index: 10000;\r\n  width: 320px;\r\n  max-width: calc(100vw - 24px);\r\n  background-color: #ffffff;\r\n  color: #303030;\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.18);\r\n  padding: 16px;\r\n  font-family: \"Roboto\";\r\n  pointer-events: auto;\r\n}\r\n\r\n.title {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #20336c;\r\n  margin: 0 0 8px;\r\n  word-break: break-word;\r\n}\r\n\r\n.image {\r\n  width: 100%;\r\n  height: 160px;\r\n  object-fit: cover;\r\n  border-radius: 12px;\r\n  background-color: #eeeeee;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.description {\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: #303030;\r\n  margin: 0 0 10px;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 6;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.empty {\r\n  font-size: 13px;\r\n  color: #6b6b6b;\r\n  text-align: center;\r\n  margin: 8px 0;\r\n}\r\n\r\n.error {\r\n  font-size: 13px;\r\n  color: #c93838;\r\n  text-align: center;\r\n  margin: 8px 0;\r\n}\r\n\r\n.sourceLink {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  color: #20336c;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.sourceLink:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.loaderWrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100px;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .infoIconBtn i {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .tooltip {\r\n    width: 280px;\r\n    padding: 12px;\r\n    border-radius: 12px;\r\n  }\r\n\r\n  .image {\r\n    height: 140px;\r\n    border-radius: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var infoIconBtn = `z126bQD8msn2Lw22`;
export var tooltip = `ODHYxlywEF80Zrwc`;
export var title = `AcBUL7jiutErC2Dn`;
export var image = `eXAIwkKJWkEq7VPH`;
export var description = `DX31dxmn3UucL516`;
export var empty = `H2otxh00CR4siz0b`;
export var error = `hXk2Jn5yP2cz1PhC`;
export var sourceLink = `y2owRiwXog8YVO2I`;
export var loaderWrapper = `GcSORYRpR9MZ28bx`;
export default ___CSS_LOADER_EXPORT___;
